window.getMall = function (login_check) {
  if(login_check)
  {
    $('#mall_modal').modal({
      keyboard: false
    });
    $('#mall_modal').modal('show');
  }
}
